<template>
  <ValidationObserver
    ref="form"
    slim
  >
    <form
      role="form"
      class="form-horizontal"
      name="vm.trustedFormSetting"
      novalidate=""
      @submit.prevent
    >
      <fieldset>
        <Field
          :label="$t('API_TOKEN')"
          :has-tooltip="true"
          :tooltip-text="$t('API_TOKEN_TT')"
        >
          <template #element>
            <ValidationProvider
              v-slot="{ classes }"
              ref="apiKey"
              rules="required"
              slim
            >
              <div :class="classes">
                <div class="col-sm-5 col-md-3">
                  <input
                    v-model="trustedFormSettingContext.apiKey"
                    type="text"
                    class="form-control"
                    @input="onInput"
                    @change="onChange"
                  >
                </div>
                <label
                  v-t="'REQUIRED'"
                  class="col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                />
              </div>
            </ValidationProvider>
          </template>
        </Field>
        <Field
          :label="$t('CERT_ID_TAG_MAPPING')"
          :has-tooltip="true"
          :tooltip-text="$t('CERT_ID_TAG_MAPPING_TT')"
        >
          <template #element>
            <ValidationProvider
              v-slot="{ classes }"
              ref="certificateTagName"
              rules="required"
              slim
            > 
              <div :class="classes">
                <div class="col-sm-5 col-md-3">
                  <input
                    v-model="trustedFormSettingContext.certificateTagName"
                    type="text"
                    class="form-control"
                    @input="onInput"
                    @change="onChange"
                  >
                </div>
                <label
                  v-t="'REQUIRED'"
                  class="col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                />
              </div>
            </ValidationProvider>
          </template>
        </Field>
      </fieldset>
    </form>
  </ValidationObserver>
</template>

<script>

import Field from '@/core/components/LabelAndElement/LabelAndElement';
import messages from './locales';

export default {
  name: 'TrustedFormSettings',
  components: {
    Field
  }, 

  props: {
    trustedFormSetting: {
      type: Object,
      default: null
    },
  },

  data() {
    return {
      trustedFormSettingContext: this.trustedFormSetting,
      defaultSetting: {
        apiKey: null,
        certificateTagName: null
      }
    };
  },

  watch: {
    'trustedFormSetting'() {
      this.trustedFormSettingContext = this.trustedFormSetting;
    },
  },

  created() {
    if (!this.trustedFormSettingContext) {
      this.trustedFormSettingContext = this.defaultSetting;
    }
  },

  methods: {
    onInput() {
      this.bubbleChanges();
    },

    onChange() {
      this.bubbleChanges();
    },

    async bubbleChanges() {
      const valid = await this.$refs.form.validate();

      this.$emit('trustedFormSettingsChange', { isFormValid: valid, value: this.trustedFormSettingContext });
    }
  },

  i18n: {
    messages,
    locale: 'en'
  } 
};
</script>

<style>

</style>